import { useState } from "react";
import { cpList } from "@/mocks/loveHelperData";

const tagStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CpSection() {
  const [selected, setSelected] = useState(cpList[0].id);
  const current = cpList.find((c) => c.id === selected) || cpList[0];

  return (
    <section id="cps" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm font-semibold text-primary-600">CP 关系</span>
          <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
            恋爱辅助器CP关系一览
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            主线、天降、往事、竹马……点选任意 CP，查看成员、感情节点与关系走向，追 CP 不迷路。
          </p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {cpList.map((cp) => (
            <button
              key={cp.id}
              type="button"
              onClick={() => setSelected(cp.id)}
              className={`flex flex-col items-center rounded-lg border px-6 py-3 transition-all ${
                selected === cp.id
                  ? "border-primary-300 bg-background-50 shadow-sm"
                  : "border-transparent bg-transparent hover:bg-background-50"
              }`}
            >
              <span
                className={`text-sm font-bold ${
                  selected === cp.id ? "text-primary-700" : "text-foreground-700"
                }`}
              >
                {cp.name}
              </span>
              <span className="mt-0.5 text-xs text-foreground-500">{cp.members}</span>
            </button>
          ))}
        </div>

        <div className="mt-10 overflow-hidden rounded-xl border border-background-200 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative h-72 w-full bg-background-200 lg:h-auto">
              <img
                src={current.image}
                alt={`${current.name} ${current.members} 恋爱辅助器CP`}
                title={`${current.name} ${current.members} 恋爱辅助器CP关系`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="flex flex-col justify-center p-6 md:p-10">
              <div className="flex items-center gap-3">
                <h3 className="text-2xl font-bold text-foreground-900">{current.name}</h3>
                <span className={`rounded-full px-3 py-1 text-xs font-semibold ${tagStyles[current.tagColor] || tagStyles.primary}`}>
                  {current.tag}
                </span>
              </div>
              <p className="mt-1 text-sm font-medium text-primary-600">{current.members}</p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                {current.summary}
              </p>
              <ul className="mt-5 space-y-3">
                {current.points.map((p, i) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-bold text-secondary-800">
                      {i + 1}
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}